module.exports = __webpack_public_path__ + "media/images/trophies-039341138449728365ec488b30609415.png";